module.exports = __webpack_public_path__ + "img/logo_prdays_2022.5b5f27b5.svg";